export default __webpack_public_path__ + "static/background-2f5162183eb54345e7a8d1184b0f0237.webp";